import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import TitleWithStar from "../../Shared/TitleWithStar";
import PricingSection from "./Components/PricingSection";

const Pricing = () => {
  const { t } = useTranslation();

  return (
    <div className="p-0">
      <Row className="mx-0">
        <TitleWithStar text={t("landing.pricing.title")} className="mt-3 mb-5"></TitleWithStar>
        <PricingSection />
      </Row>
    </div>
  );
};

export default Pricing;
